import React, { FC } from 'react';
import { Category } from 'shared/types/product/Category';
import MobileMenuNavButton from '../atoms/menu-nav-button';
import Markdown from 'components/commercetools-ui/organisms/markdown';
import Link from 'components/commercetools-ui/atoms/link';
import { useAccount } from 'frontastic';

export interface Props {
  links: any[];
  topRightMenu: any;
  hideHeaderMenu: () => void;
  onArrowClick: () => void;
  categoriesNavigator?: any[]; //This is a navigator where you push a subcategory to show it's contents
  insertCategory: (category: Category) => void;
  setShowSignupPopup?: any;
}

const MobileMenu: FC<Props> = ({
  links,
  topRightMenu,
  categoriesNavigator,
  insertCategory,
  hideHeaderMenu,
  onArrowClick,
  setShowSignupPopup,
}) => {
  const { loggedIn } = useAccount();

  return (
    <div className="h-full overflow-y-auto py-16">
      {links?.map((link) => {
        return (
          <MobileMenuNavButton
            key={link?.title || link.label}
            categoriesNavigator={categoriesNavigator}
            link={link}
            onClick={() => insertCategory(link)}
            hideHeaderMenu={hideHeaderMenu}
          />
        )
        
      })}
       <Link
              key={links?.[1]?.mega_menu[links[1]?.mega_menu.length - 1]?.categoryId}
              link={links?.[1]?.mega_menu[links[1]?.mega_menu.length - 1]?.mega_menu_url?.href}
              className="markdown-custom"
              target={links?.[1]?.mega_menu[links[1]?.mega_menu.length - 1]?.mega_menu_url?.href?.includes('https://') ? '_blank' : ''}
            >
      <Markdown
        className="solutions-img"
        markdown={links?.[1]?.mega_menu[links[1]?.mega_menu.length - 1]?.mega_menu_content}
        />
        </Link>
      {topRightMenu && (
        <div className="mt-32 flex flex-col items-center gap-8">
          {topRightMenu.map((link: any) =>
            link.menu_links.title.toLowerCase() === 'sign up/sign in' ? (
              <>
                {loggedIn ?
                  <></> : <span
                    key={link.menu_links.title}
                    role="button"
                    onClick={() => {
                      hideHeaderMenu();
                      setShowSignupPopup(true)
                    }}
                    className="flex items-center text-14 font-medium text-[#666] hover:cursor-pointer hover:text-[#333]"
                  >
                    {link.menu_links.title}
                  </span>
                }
              </>
            ) : (
              <Link key={link.menu_links.title} link={link.menu_links.href} rel="noopener noreferrer" target="_blank">
                <span className="flex items-center text-14 font-medium text-[#666] hover:cursor-pointer hover:text-[#333]">
                  {link.menu_links.title}
                </span>
              </Link>
            ),
          )}
        </div>
      )}
    </div>
  );
};

export default MobileMenu;
